// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"681":"a1950b89","718":"5ae15adf","875":"bb89ded3"}[chunkId] + ".chunk.css";
};